import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withKeys as _withKeys, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { style: {"position":"fixed","z-index":"700"} }
const _hoisted_5 = { style: {"background-color":"rgb(196, 197, 197)","margin-top":"0px","width":"490px"} }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1)

import { reactive, ref, onMounted, onUnmounted,watch } from 'vue';
import { ElMessage } from 'element-plus';
import { Search,CloseBold } from '@element-plus/icons-vue';
import $http from '../http/index';
import $helper from '../helper/helper';

// 入参
interface CarModelInfo{
    carModel:string, //车型
    brands:string,   //品牌
    factory:string   //厂家
}

/**
 * 查询过滤条件
 */
interface carModelFilterCondition{
    brand:string,
    drivingType:string,
    saleTimeYear:string,
    marketSources :string,
    factorys :string,
    carModel :string,
    sortNo :string
}

interface BrandInfo{
    brand:string,       //品牌名称
    sortNo:string,  //排序号
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CarModelSearch',
  props: {
    isShowInput: { type: Boolean }
  },
  emits: ['showCarModelSearchData','showCarModelSearchDataTotalMsg','searching','searched'],
  setup(__props: any, { emit }) {

const props = __props as {
    isShowInput:boolean
};





// 国家/地区（localStorage 非响应式，定时同步到 ref 后再监听）
const nationalRegion = ref(window.localStorage.getItem("nationalRegion") ?? '');

let intervalResult = -1;
onMounted(()=>{
    // window.setTimeout(()=>{
        
    // },4000);
    filterConditionDataInit();
    intervalResult = window.setInterval(()=>{
        data.windowWidthAndHeight = window.innerWidth+"-"+window.innerHeight;
        nationalRegion.value = window.localStorage.getItem("nationalRegion") ?? '';
    },500)
    setSearchHistories('');
})

onUnmounted(()=>{
    if(intervalResult!=-1){
        window.clearInterval(intervalResult);
    }
})

/**
 * 车型信息
 */
class InitData{
    warpStyle={
        left: '150px',
        top:'112px',
    }
    windowWidthAndHeight='' //窗口的宽高
    carModelFilterConditions:Array<carModelFilterCondition>=[] //查询条件
    brand:Array<string>=[] //选中品牌 
    drivingType:Array<string>=[] //燃油类别
    saleTimeYear:Array<string>=[] //制造年份
    marketSource:Array<string>=[] //来源
    factory:Array<string>=[] //厂家
    carModelID=''//车型ID
    engineModel=''//发动机号码
    carModel:Array<string>=[]//车型
    searchCondition=''//模糊查询
    taxiIcon= require('../assets/images/taxi.png')
    tramIcon= require('../assets/images/tram.png')
    truckIcon= require('../assets/images/truck.png')
    brands:Array<BrandInfo>=[]
    drivingTypes:Array<string>=[]
    saleTimeYears:Array<string>=[]
    marketSources:Array<string>=[]
    factorys:Array<string>=[]
    carModels:Array<string>=[]
    carModelInfoes:Array<CarModelInfo>=[]
    isShowSearchHistory=false //是否显示模糊查询历史查询
    searchConditionHistories:Array<string>=[]
}

const data = reactive(new InitData());

/**
 * 设置整个显示层的位置
 */
const setSite=()=>{
    let left = (window.innerWidth-1200)/2+5;
    if(left<5){
        left=55;
    }
    let leftStr = `${left}px`;
    if(leftStr!=data.warpStyle.left){
        data.warpStyle.left = `${left}px`;
    }
}

/**
 * 通过监听isShowInput值，计算设置整个显示层的位置。
 */
watch(()=>props.isShowInput,()=>{
    setSite();
})

watch(()=>data.windowWidthAndHeight,()=>{
    data.warpStyle.left = `5px`;
    setSite();
})

/**
 * 过滤条件数据初始化
 */
const filterConditionDataInit = ()=>{
    $http({
        url: "/API/Product/GetCarModelFilterConditions",
        method: "GET",
        data: {}
    }).then(res => {
        data.carModelFilterConditions = JSON.parse(res.data);
        let brands:Array<BrandInfo> = [];
        for(let i=0;i<data.carModelFilterConditions.length;i++){
            let brand = data.carModelFilterConditions[i].brand;
            if(brands.findIndex(c=>c.brand==brand)>-1){
                continue;
            }
            brands.push({brand:brand,sortNo:data.carModelFilterConditions[i].sortNo});
        }
        data.brands = brands;
    })
}

/**
 * 查询操作
 */
const search = () =>{
    let searchID = $helper.createID()
    let searchInputTemp = data.searchCondition
    for(let i=0;i<100;i++){
        searchInputTemp = searchInputTemp.replaceAll(",","").replaceAll("_","").replaceAll("/","").replaceAll(" ","");
    }
    data.searchCondition=searchInputTemp;
    let serchParam={
        SearchID:searchID,
        Brand:data.brand,
        SaleTimeYear:data.saleTimeYear,
        DrivingType:data.drivingType,
        MarketSource:data.marketSource,
        Factory:data.factory,
        CarModelID:data.carModelID,
        CarModel:data.carModel,
        EngineModel:data.engineModel,
        SearchCondition:data.searchCondition
    };
    emit("searching")
    $http({
        url: "/API/Product/CarModelSearch",
        method: "POST",
        data: {
            searchCondition: JSON.stringify(serchParam),
        }
    }).then(res => {
        if(res.data.length<1){
            ElMessage({
                message: $helper.lan('暂无数据提供'),
                type: 'warning',
            })
        }
        for(let i=0;i<res.data.length;i++){
            res.data[i].MapCode = ''
        }
        getSearchTotalMsg(searchID);
        emit("showCarModelSearchData",JSON.stringify(res.data));
        emit("searched");
        if(res.data.length>0){
            setSearchHistories(data.searchCondition);
        }
    }).finally(()=>{
        emit("searched");
    })
}

const getSearchTotalMsg = (searchID:string)=>{
    $http({
        url: "/API/Product/CarModelSearchTotalMsg",
        method: "POST",
        data: {
            SearchID: searchID,
        }
    }).then(res => {
        emit('showCarModelSearchDataTotalMsg',res.data.toString());
    })
}

const resetSearchConditon=()=>{
    data.brand = [];
    data.saleTimeYear = [];
    data.drivingType = [];
    data.marketSource = [];
    data.factory = [];
    data.carModelID = '';
    data.carModel = [];
    data.searchCondition='';
    data.engineModel='';
    emit('showCarModelSearchData','[]');
    emit('showCarModelSearchDataTotalMsg',$helper.lan('暂无数据'));
}

/**
 * 制造年份
 */
watch(()=>JSON.stringify(data.brand)+JSON.stringify(data.factory)+JSON.stringify(data.carModel),()=>{
    let yearArray:Array<string> = [];
    for(let i=0;data.carModelFilterConditions&&i<data.carModelFilterConditions.length;i++){
        let condition = data.carModelFilterConditions[i];
        if(data.brand.findIndex(c=>c==condition.brand)<0)continue;
        if(data.factory.length>0 && data.factory.findIndex(c=>c==condition.factorys)<0)continue;
        if(data.carModel.length>0 && data.carModel.findIndex(c=>c==condition.carModel)<0)continue;
        if(yearArray.findIndex(c=>c==condition.saleTimeYear)>-1)continue;
        yearArray.push(condition.saleTimeYear);
    }
    yearArray = yearArray.toSorted();
    yearArray.reverse();
    data.saleTimeYears = yearArray;
    data.saleTimeYear=[];
})

/**
 * 燃料类别
 */
watch(()=>data.carModelFilterConditions,()=>{
    let drivingTypeArray:Array<string> = [];
    for(let i=0;data.carModelFilterConditions&&i<data.carModelFilterConditions.length;i++){
        let condition = data.carModelFilterConditions[i];
        if(drivingTypeArray.findIndex(c=>c==condition.drivingType)>-1)continue;
        drivingTypeArray.push(condition.drivingType);
    }
    drivingTypeArray = drivingTypeArray.toSorted();
    data.drivingTypes = drivingTypeArray;
    data.drivingType=[];
})

/**
 * 来源
 */
watch(
    ()=>data.carModelFilterConditions,
    ()=>{
        let marketSourceArray:Array<string> = [];
        for(let i=0;data.carModelFilterConditions&&i<data.carModelFilterConditions.length;i++){
            let condition = data.carModelFilterConditions[i];
            if(marketSourceArray.findIndex(c=>c==condition.marketSources)>-1)continue;
            marketSourceArray.push(condition.marketSources);
        }
        marketSourceArray= marketSourceArray.toSorted();
        data.marketSources = marketSourceArray;
        data.marketSource=[];
})

/**
 * 厂家
 */
watch(
    ()=>JSON.stringify(data.brand),
    ()=>{
        let factoryArray:Array<string> = [];
        for(let i=0;data.carModelFilterConditions&&i<data.carModelFilterConditions.length;i++){
            let condition = data.carModelFilterConditions[i];
            if(data.brand.findIndex(c=>c==condition.brand)<0)continue;
            if(factoryArray.findIndex(c=>c==condition.factorys)>-1)continue;
            factoryArray.push(condition.factorys);
        }
        data.factorys = factoryArray;
        data.carModel=[];
})

/**
 * 车型
 */
watch(
    ()=>JSON.stringify(data.brand)+JSON.stringify(data.factory),
    ()=>{
        let carModelArray:Array<string> = [];
        for(let i=0;data.carModelFilterConditions&&i<data.carModelFilterConditions.length;i++){
            let condition = data.carModelFilterConditions[i];
            if(data.brand.findIndex(c=>c==condition.brand)<0)continue;
            if(data.factory.findIndex(c=>c==condition.factorys)<0)continue;
            if(carModelArray.findIndex(c=>c==condition.carModel)>-1)continue;
            carModelArray.push(condition.carModel);
        }
        data.carModels = carModelArray;
})

/**
 * 国家发生变化
 */
watch(
    nationalRegion,
    ()=>{
        filterConditionDataInit();
})

const showSearchHistory = ()=>{
    data.isShowSearchHistory=true
};

const hideSearchHistory = ()=>{
    window.setTimeout(function(){
        data.isShowSearchHistory=false
    },300);
};

const searchHistoryClick = (code:string)=>{
    data.searchCondition =code;
    search()
}

/**
 * 设置查询历史
 * @param code 
 */
const setSearchHistories = (code:string)=>{
    let searchHistories:Array<string> = [];
    if(code){
        searchHistories.push(code);
    }
    const codeSearchHistoriesJson = window.localStorage.getItem("carModelSearchHistories");
    if(codeSearchHistoriesJson!=null){
        const cacheData:Array<string> = JSON.parse(codeSearchHistoriesJson);
    for(let i=0;cacheData&&i<cacheData.length;i++){
        if(searchHistories.indexOf(cacheData[i])>-1)continue;
            searchHistories.push(cacheData[i]);
        }
    }
    if(searchHistories.length>6){
        searchHistories = searchHistories.slice(0,6)
    }
    data.searchConditionHistories = searchHistories;
    window.localStorage.setItem("carModelSearchHistories",JSON.stringify(data.searchConditionHistories));
}


return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "carModelSearch_warpStyle",
    style: _normalizeStyle(data.warpStyle)
  }, [
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 1 }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              alt: "logo",
              class: "carModelSearch_carTypeIcon",
              src: data.taxiIcon
            }, null, 8, _hoisted_1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 8 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: data.brand,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((data.brand) = $event)),
              class: "m-2",
              placeholder: _unref($helper).lan('选择品牌'),
              multiple: "true",
              "collapse-tags": "true",
              filterable: "",
              style: {"width":"388px","margin-top":"3px"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.brands, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.brand,
                    label: item.sortNo+' '+item.brand,
                    value: item.brand
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 5 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: data.saleTimeYear,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((data.saleTimeYear) = $event)),
              class: "m-2",
              placeholder: _unref($helper).lan('选择制造年份'),
              multiple: "true",
              "collapse-tags": "true",
              filterable: "",
              style: {"width":"240px","margin-top":"3px"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.saleTimeYears, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item,
                    label: item,
                    value: item
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 5 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: data.drivingType,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((data.drivingType) = $event)),
              class: "m-2",
              placeholder: _unref($helper).lan('选择燃料类别'),
              multiple: "true",
              "collapse-tags": "true",
              style: {"width":"240px","margin-top":"3px"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.drivingTypes, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item,
                    label: _unref($helper).lan(item),
                    value: item
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 5 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: data.marketSource,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((data.marketSource) = $event)),
              class: "m-2",
              placeholder: _unref($helper).lan('选择来源'),
              multiple: "true",
              "collapse-tags": "true",
              style: {"width":"240px","margin-top":"3px"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.marketSources, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item,
                    label: _unref($helper).lan(item),
                    value: item
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 1 }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              alt: "logo",
              class: "carModelSearch_carTypeIcon",
              src: data.truckIcon
            }, null, 8, _hoisted_2)
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 8 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: data.factory,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((data.factory) = $event)),
              class: "m-2",
              placeholder: _unref($helper).lan('选择厂家/制造商'),
              multiple: "true",
              "collapse-tags": "true",
              filterable: "",
              style: {"width":"388px","margin-top":"3px"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.factorys, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item,
                    label: item,
                    value: item
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 5 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: data.carModelID,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((data.carModelID) = $event)),
              class: "w-50 m-2",
              placeholder: _unref($helper).lan('输入车型ID'),
              style: {"width":"240px","margin-top":"3px"},
              onKeydown: _withKeys(search, ["enter"])
            }, null, 8, ["modelValue", "placeholder", "onKeydown"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 10 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: data.engineModel,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((data.engineModel) = $event)),
              class: "w-50 m-2",
              placeholder: _unref($helper).lan('输入发动机号码'),
              style: {"width":"490px","margin-top":"3px"},
              onKeydown: _withKeys(search, ["enter"])
            }, null, 8, ["modelValue", "placeholder", "onKeydown"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 1 }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              alt: "logo",
              class: "carModelSearch_carTypeIcon",
              src: data.tramIcon
            }, null, 8, _hoisted_3)
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 8 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: data.carModel,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((data.carModel) = $event)),
              class: "m-2",
              placeholder: _unref($helper).lan('选择车型'),
              multiple: "true",
              "collapse-tags": "true",
              filterable: "",
              style: {"width":"388px","margin-top":"3px","margin-bottom":"3px"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.carModels, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item,
                    label: item,
                    value: item
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 10 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: data.searchCondition,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((data.searchCondition) = $event)),
              class: "w-50 m-2",
              placeholder: _unref($helper).lan('输入模糊查询信息'),
              style: {"width":"490px","margin-top":"3px","margin-bottom":"3px"},
              onKeydown: _withKeys(search, ["enter"]),
              onFocus: showSearchHistory,
              onBlur: hideSearchHistory
            }, null, 8, ["modelValue", "placeholder", "onKeydown"]),
            _withDirectives(_createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.searchConditionHistories, (code) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: code+_unref($helper).createID(),
                    style: {"float":"left","width":"45%","padding":"5px"}
                  }, [
                    _createElementVNode("span", {
                      style: {"cursor":"pointer"},
                      onClick: ($event: any) => (searchHistoryClick(code))
                    }, _toDisplayString(code), 9, _hoisted_6)
                  ]))
                }), 128)),
                _hoisted_7
              ])
            ], 512), [
              [_vShow, data.isShowSearchHistory]
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 5 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              icon: _unref(Search),
              style: {"width":"111px","margin-top":"3px","margin-left":"3px"},
              onClick: search
            }, {
              default: _withCtx(() => [
                _createElementVNode("b", null, _toDisplayString(_unref($helper).lan('查询')), 1)
              ]),
              _: 1
            }, 8, ["icon"]),
            _createVNode(_component_el_button, {
              icon: _unref(CloseBold),
              style: {"width":"111px","margin-top":"3px"},
              onClick: resetSearchConditon
            }, {
              default: _withCtx(() => [
                _createElementVNode("b", null, _toDisplayString(_unref($helper).lan('重置')), 1)
              ]),
              _: 1
            }, 8, ["icon"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 4)), [
    [_vShow, props.isShowInput]
  ])
}
}

})